import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

import { PropTypesRepo } from '../functions/_propTypes';
import { functions } from '../functions/_functions';

import Div from './Div';
import Button from './Button';

/* eslint-disable no-nested-ternary */

/**
 * Duration for the transition
 */
const duration = 300;

/**
 * Default Style for Backlayer
 */
const defaultBackLayerStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

/**
 * Trasition Styles for Backlayer
 */
const backLayerTransitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 0.2 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

/**
 * Default Style for SlideshowCanvas
 */
const defaultSlideshowCanvasStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
};

/**
 * Trasition Styles for SlideshowCanvas
 */
const transitionSlideshowCanvasStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

/**
 * Default Style for SlideshowContent
 */
const defaultSlideshowContentStyle = {
  transition: `all ${duration}ms ease-in-out`,
  opacity: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
};

/**
 * Trasition Styles for SlideshowContent
 */
const transitionSlideshowContentStyles = {
  entering: {
    forward: { opacity: 0, transform: 'translateX(100%)' },
    backward: { opacity: 0, transform: 'translateX(-100%)' },
  },
  entered: {
    forward: { opacity: 1, transform: 'translateX(10%)' },
    backward: { opacity: 1, transform: 'translateX(10%)' },
  },
  exiting: {
    forward: { opacity: 1, transform: 'translateX(10%)' },
    backward: { opacity: 1, transform: 'translateX(10%)' },
  },
  exited: {
    forward: { opacity: 0, transform: 'translateX(-100%)' },
    backward: { opacity: 0, transform: 'translateX(100%)' },
  },
};

class Slideshow extends Component {
  constructor(props) {
    super(props);
    this.disableBodyScroll = this.disableBodyScroll.bind(this);
    this.enableBodyScroll = this.enableBodyScroll.bind(this);
    this.state = {
      slideIndex: 0,
      direction: 'forward',
    };
  }

  componentWillUnmount() {
    document.querySelector('body').style.overflow = 'auto';
  }

  /**
   * Disable the body scroll when Opened
   */
  disableBodyScroll() {
    document.querySelector('body').style.overflow = 'hidden';

    // Start Function if recieved a onEntering Props
    const { onEntering } = this.props;
    if (onEntering) onEntering();
  }

  /**
   * Enable the body scroll when Closed
   */
  enableBodyScroll() {
    document.querySelector('body').style.overflow = 'auto';

    // Start Function if recieved a onExiting Props
    const { onExiting } = this.props;
    if (onExiting) onExiting();
  }

  render() {
    const {
      slides,
      isOpen,
      onClose,
      align,
      navProps,
      navButtonProps,
      contentProps,
      firstSlideButtonText,
      lastSlideButtonText,
      forwardButtonText,
      backwardButtonText,
      ...rest
    } = this.props;
    const { direction, slideIndex } = this.state;
    return (
      <Transition
        in={isOpen}
        timeout={duration}
        onEntering={this.disableBodyScroll}
        onExiting={this.enableBodyScroll}
        onExited={() => {
          this.setState({
            slideIndex: 0,
          });
        }}
        unmountOnExit
      >
        {(state) => (
          <>
            <Div
              style={{
                ...defaultBackLayerStyle,
                ...backLayerTransitionStyles[state],
              }}
              pos="fixed"
              top="0"
              left="0"
              right="0"
              bottom="0"
              bg="black"
              opacity="0.4"
              zIndex="1000"
            />
            <Div
              style={{
                ...defaultSlideshowCanvasStyle,
                ...transitionSlideshowCanvasStyles[state],
              }}
              onClick={onClose}
              pos="fixed"
              top="0"
              left="0"
              right="0"
              h="100vh"
              d="flex"
              align={align}
              justify="center"
              zIndex="1001"
              cursor="pointer"
            >
              <Div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                bg="white"
                {...rest}
                zIndex="1"
              >
                {functions.range(0, slides.length - 1, 1).map((value) => (
                  <Transition in={slideIndex === value} timeout={duration}>
                    {(innerTransitionState) => (
                      <Div
                        d="flex"
                        w="80%"
                        pos="absolute"
                        align="center"
                        justify="center"
                        style={{
                          ...defaultSlideshowContentStyle,
                          ...transitionSlideshowContentStyles[innerTransitionState][direction],
                        }}
                        {...contentProps}
                      >
                        {slides[value]}
                      </Div>
                    )}
                  </Transition>
                ))}
                <Div {...navProps}>
                  {slideIndex > 0 ? (
                    <Button
                      onClick={() => {
                        if (slideIndex > 0) {
                          this.setState((prevState) => ({
                            slideIndex: (prevState.slideIndex - 1) % slides.length,
                            direction: 'backward',
                          }));
                        }
                      }}
                      {...navButtonProps}
                    >
                      {backwardButtonText}
                    </Button>
                  ) : null}
                  {slideIndex < slides.length ? (
                    <Button
                      onClick={() => {
                        if (slideIndex === slides.length - 1) {
                          onClose();
                        } else {
                          this.setState((prevState) => ({
                            slideIndex: (prevState.slideIndex + 1) % slides.length,
                            direction: 'forward',
                          }));
                        }
                      }}
                      {...navButtonProps}
                    >
                      {slideIndex === 0
                        ? firstSlideButtonText
                        : slideIndex === slides.length - 1
                          ? lastSlideButtonText
                          : forwardButtonText}
                    </Button>
                  ) : null}
                </Div>
              </Div>
            </Div>
          </>
        )}
      </Transition>
    );
  }
}

/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */

Slideshow.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.node),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onEntering: PropTypes.func,
  onExiting: PropTypes.func,
  align: PropTypesRepo.align,
  navProps: PropTypes.object,
  navButtonProps: PropTypes.object,
  contentProps: PropTypes.object,
  forwardButtonText: PropTypes.string,
  backwardButtonText: PropTypes.string,
  firstSlideButtonText: PropTypes.string,
  lastSlideButtonText: PropTypes.string,
};

/* eslint-enable react/forbid-prop-types */
/* eslint-enable react/require-default-props */

/* eslint-disable react/default-props-match-prop-types */

Slideshow.defaultProps = {
  m: { y: { xs: '16px', lg: '32px' }, x: { xs: '16px', lg: 'auto' } },
  maxW: '512px',
  w: '100%',
  pos: 'fixed',
  rounded: 'md',
  shadow: '4',
  cursor: 'default',
  align: 'start',
  onClose: () => {},
  onEntering: null,
  onExiting: null,
  isOpen: false,
  navProps: {
    m: { t: '128px', b: '32px' },
    d: 'flex',
    flexDir: 'row',
    justify: 'center',
  },
  navButtonProps: {
    m: { x: '16px' },
    w: '80px',
  },
  contentProps: {
    top: '32px',
  },
  forwardButtonText: 'Next',
  backwardButtonText: 'Back',
  firstSlideButtonText: 'Next',
  lastSlideButtonText: 'Finish',
};

/* eslint-enable react/default-props-match-prop-types */

export default Slideshow;
